import { FormSectionHandler } from '../entity.handler';
import { UserRoleResponse, UserRoleUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { CheckListField } from '../utils';
import { LEGACY_RIGHTS } from './legacy-rights';

interface EditorValues {
    [key: string]: string[];
}

export class UserRoleRightsSectionHandler implements FormSectionHandler<UserRoleResponse, EditorValues> {

    type = 'form';
    icon = 'key';
    bulk = false;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.USERROLE.RIGHTS.${key}`, values);
    }

    applyUpdate(entity: UserRoleResponse, payload: UserRoleUpdateRequest): Promise<UserRoleResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateUserRole(entity.id, payload));
    }

    mapEntityToEditor(entity: UserRoleResponse): Promise<EditorValues> {
        return Promise.resolve(entity.legacyRights || {});
    }

    mapEditorToEntity(entity: UserRoleUpdateRequest, values: EditorValues): Promise<UserRoleUpdateRequest> {
        entity.legacyRights = entity.legacyRights || {};
        Object.keys(values).forEach(key => {
            entity.legacyRights[key] = values[key];
        });
        return Promise.resolve(entity);
    }

    async getFields(_entity: UserRoleResponse): Promise<FormBuilderField[]> {
        const companyType = this.ownerId === '00000000-0000-0000-0000-000000000000' ? 'system' : (await this.admin.getCached(`getCompany/${this.ownerId}`, api => api.accounts.getCompany(this.ownerId))).type;
        const legacyRights = LEGACY_RIGHTS[companyType];
        return legacyRights.map(rights => {
           
            return {
                ...CheckListField(rights.name, rights.title, false, rights.rights.map(x => ({ key: x.name, value: x.title }))),
                getText: (field: FormBuilderField, values: any) => {
                    return (values[field.id] || []).map(key => field.values.find(x => x.key === key).value).join(', ');
                },
            };
    
        });
    }

}


